// The mark for a messaging channel, beside its name in a table or a receipt.
// Decorative: the channel's name is always written next to it.

export function ChannelIcon({ channel, size = 16 }: { channel: string; size?: number }) {
  return (
    <svg
      className="as-channel-icon"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {channel === 'WHATSAPP' ? (
        <>
          <path d="M3.2 13.2l.8-2.5A5.5 5.5 0 1 1 6 12.6z" />
          <path d="M6.2 5.8c.2 1.9 1.9 3.7 4 4l.7-.9-1.2-.6-.5.5a2.6 2.6 0 0 1-1.9-1.9l.5-.5-.6-1.2z" />
        </>
      ) : channel === 'SMS' ? (
        <>
          <rect x="4" y="2" width="8" height="12" rx="1.6" />
          <path d="M7 11.5h2" />
        </>
      ) : channel === 'OWNER' ? (
        <>
          <circle cx="8" cy="6" r="2.5" />
          <path d="M3.5 13.5c.8-2.4 2.5-3.5 4.5-3.5s3.7 1.1 4.5 3.5" />
        </>
      ) : (
        <>
          <rect x="2" y="3.5" width="12" height="9" rx="1.5" />
          <path d="M2.5 4.5 8 9l5.5-4.5" />
        </>
      )}
    </svg>
  )
}
